import React from 'react';
import TeamSIngleBlog from '../../../../components/TeamSIngleBlog/TeamSIngleBlog';

const HomeTwoBlogs = () => {
    return (
        <>
            <section className="tp-blog-area-two pt-50 pb-50 mt-1" style={{background:"#666464"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-title-wrapper-two mb-30 text-center wow fadeInUp" data-wow-delay=".2s">
                                <h2 className="tp-section-title-two " style={{color:"white"}}>NeoGrowth <span className='theme-yellow' >MSME</span> Festival Highlights </h2>                                
                            </div>
                        </div>
                    </div>
                    {/* <div className="tp-pricing-two-btn mb-20 pt-10">
                     <Link to="/" className="yellow-btn" style={{borderRadius: "10px"}} >Know More</Link>
                    </div> */}
                    <div className="row" style={{justifyContent: "center"}}>
                        <TeamSIngleBlog image_num="10" date="10" textt="Bangalore Event" linkk="https://www.youtube.com/watch?v=r-tJpozACSo" vIds="r-tJpozACSo" />
                        <TeamSIngleBlog image_num="11" date="11" textt="Hyderabad Event" linkk="https://www.youtube.com/watch?v=jUbq-xxwnrM" vIds="jUbq-xxwnrM" />
                        {/* <TeamSIngleBlog image_num="6" date="12" /> */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default HomeTwoBlogs;